import {
  REQUESTTIME_REASON_FETCHING,
  REQUESTTIME_REASON_SUCCESS,
  REQUESTTIME_REASON_FAILED,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case REQUESTTIME_REASON_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case REQUESTTIME_REASON_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case REQUESTTIME_REASON_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
